import { ArrowLeftIcon } from '@phosphor-icons/react';
import { Color, Style } from 'src/constants';

import { RouterLink, Stack, Text } from '.';

type Props = {
  title: string | React.ReactNode;
  back: {
    label: string;
    to: string;
  } | null;
};

export default function PageHeader({ title, back }: Props) {
  return (
    <Stack gap={0.25}>
      {back && (
        <Stack style={Style.alignStart}>
          <RouterLink to={back.to}>
            <Stack style={[Style.row, Style.alignCenter]} gap={0.25}>
              <ArrowLeftIcon size={16} color={Color.neutral80} />
              <Text typeface="body.medium">{back.label}</Text>
            </Stack>
          </RouterLink>
        </Stack>
      )}
      {typeof title === 'string' ? (
        <Text typeface="headline">{title}</Text>
      ) : (
        title
      )}
    </Stack>
  );
}
